import React from "react";
import ContentCard from "../../Components/ContentCard";


const Dashboard = () => {
  const mainContent = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full p-6">
      <ContentCard
        title="PDF Zusammenfügen"
        description="Fügen Sie mehrere PDF-Dateien zu einer einzigen Datei zusammen."
        link="/pdf-zusammenfuegen"
        iconName="copy-plus"
      />

      <ContentCard
        title="Seiten neu anordnen und löschen"
        description="Ordnen Sie die Seiten Ihrer PDF-Dateien neu an oder löschen Sie unerwünschte Seiten."
        link="/pdf-seiten-löschen"
        iconName="edit"
      />

      <ContentCard
        title="Metadaten bearbeiten"
        description="Bearbeiten Sie die Metadaten Ihrer PDF-Dateien."
        link="/pdf-metadaten-bearbeiten"
        iconName="code-dots"
      />

      <ContentCard
        title="Wasserzeichen hinzufügen"
        description="Fügen Sie Wasserzeichen zu Ihren PDF-Dateien hinzu."
        link="/pdf-wasserzeichen-hinzufuegen"
        iconName="trademark"
      />

      <ContentCard
        title="Seiten drehen"
        description="Drehen Sie die Seiten Ihrer PDF-Dateien."
        link="/pdf-seiten-drehen"
        iconName="rotate-2"
      />
    </div>
  );

  return mainContent();
};

export default Dashboard;
